import { ImsObjectIncrementalCollection } from 'app/shared/collections/ims_object_incremental_collection.service';
import { ZoneResource } from 'app/shared/resources';
import { Zone } from 'app/shared/collections/zones/zone';
import { NEW_ZONE_KEY } from 'app/shared/zones/zone.service';
import ZoneTypeCollection from './zone_type_collection.service';
import { ZoneHistoryCollection } from './zone_history_collection.service';
import { ViewStateService } from '../../view_state.service';
import { SiteStateService } from '../../site_state.service';
import { StartupRegistry } from 'app/startup/registry/registry';
import Constant from 'app/shared/utilities/constant';

import { ILocalStorageService } from 'angular-local-storage';

/**
 * @ngdoc service
 * @name ims.shared.data.service:zoneCollection
 * @description
 * A collection of ims Zone objects. It handles loading and refreshing data.
 *
 */
export class ZoneCollection extends ImsObjectIncrementalCollection {
    temporaryUnsavedZone;

    constructor(
        startUpRegistry: StartupRegistry,
        localStorageService: ILocalStorageService,
        $rootScope,
        $interval,
        zoneTypeCollection: ZoneTypeCollection,
        zoneHistoryCollection: ZoneHistoryCollection,
        viewStateService: ViewStateService,
        siteStateService: SiteStateService,
    ) {
        super(
            startUpRegistry,
            localStorageService,
            $rootScope,
            $interval,
            viewStateService,
            siteStateService,
            ZoneResource,
            Zone,
        );

        this.defineRelationship('type', null, 'type_id', zoneTypeCollection);
        this.defineRelationship('historyPoints', 'zone_id', null, zoneHistoryCollection);

        // HACK to get around the fact that when drawing a new zone, the zone service selects the zone, so it can show up in the info box.
        // However the zone doesn't have an ID yet which is required for the current SelectionService implementation.
        // So we give it a special ID when selecting it. Also the unsaved zone IMS Object is not stored anywhere, so we store it here.
        this.temporaryUnsavedZone = undefined;
    }

    get(id) {
        if (id === NEW_ZONE_KEY) {
            return this.temporaryUnsavedZone;
        }
        return super.get(id);
    }

    refreshData(params = {}, checkTime = false, useInFlightCheck = false) {
        return super.refreshData(
            {
                site_id: this._siteStateService.selectedSiteId,
            },
            checkTime,
            useInFlightCheck,
        );
    }

    /**
     * Filters out zones based on name and the logged in user and whether
     * the zone description contains the FILTER_KEYWORD
     * @param zones
     * @returns An object of zones with certain items filtered out.
     */
    _filterInternal(zones) {
        return zones;
    }
}
